import React from "react";
import "./assets/css/setup.css";
import "./assets/css/style.css";
import "./assets/css/font.css";
import "./assets/css/responsive.css";
import "./assets/css/humburger.css";
import "./assets/css/mentions-legals.css";
import Main from "./pages/Main.jsx";
import Contact from "./pages/Contact.jsx";
import Formations from "./pages/Formations.jsx";
import "bootstrap/dist/css/bootstrap.min.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import Satisfaction from "./pages/Satisfaction.jsx";
import SatisfactionFinanceurs from "./pages/Satisfaction-financeurs.jsx";
import FicheClientEntreprise from "./pages/Fiche-client-entreprise.jsx";
import FicheClientParticulier from "./pages/Fiche-client-particulier.jsx";
/* IMPORTS BUREAUTIQUE SUR MESURE */
import EvaluationInitialeBureautique from "./pages/Evaluation-initiale-bureautique.jsx";
import EvaluationFinaleBureautique from "./pages/Evaluation-final-bureautique.jsx";
import ExerciceMiParcoursBureautique from "./pages/Exercice-mi-parcours-bureautique.jsx";
/* IMPORTS MAITRISER LES BASES DE WORDPRESS */
import EvaluationInitialeWP from "./pages/Evaluation-initiale-maitriser-bases-wordpress.jsx";
import EvaluationFinaleWP from "./pages/Evaluation-final-maitriser-bases-wordpress.jsx";
import ExerciceMiParcoursWP from "./pages/Exercice-mi-parcours-maitriser-bases-wordpress.jsx";
/* IMPORTS RENFORCEMENT BUREAUTIQUE */
import EvaluationInitialeRenforcementBureautique from "./pages/Evaluation-initiale-renforcement-bureautique.jsx";
import ExerciceMiParcoursRenforcementBureautique from "./pages/Exercice-renforcement-bureautique.jsx";
import EvaluationFinaleRenforcementBureautique from "./pages/Evaluation-finale-renforcement-bureautique.jsx";
/* */
import LinktreeSlider from "./components/linktree/linktree.jsx";

import MentionsLegales from "./pages/MentionLegales.jsx";

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route index element={<Main />}></Route>
        <Route path="/contact/" element={<Contact />}></Route>
        <Route path="/formations/" element={<Formations />}></Route>
        <Route path="/satisfaction/" element={<Satisfaction />}></Route>
        <Route
          path="/satisfaction-financeurs/"
          element={<SatisfactionFinanceurs />}
        ></Route>
        <Route
          path="/fiche-client-entreprise/"
          element={<FicheClientEntreprise />}
        ></Route>
        <Route
          path="/fiche-client-particulier/"
          element={<FicheClientParticulier />}
        ></Route>
        <Route path="/linktree/" element={<LinktreeSlider />}></Route>
        {/* BUREAUTIQUE SUR MESURE */}
        <Route
          path="/evaluation-bureautique-initiale/"
          element={<EvaluationInitialeBureautique />}
        ></Route>
        <Route
          path="/exercice-bureautique-mi-parcours/"
          element={<ExerciceMiParcoursBureautique />}
        ></Route>
        <Route
          path="/evaluation-bureautique-finale/"
          element={<EvaluationFinaleBureautique />}
        ></Route>
        {/* MAITRISER LES BASES DE WORDPRESS */}
        <Route
          path="/evaluation-maitriser-bases-wordpress-initiale/"
          element={<EvaluationInitialeWP />}
        ></Route>
        <Route
          path="/exercice-maitriser-bases-wordpress/"
          element={<ExerciceMiParcoursWP />}
        ></Route>
        <Route
          path="/evaluation-maitriser-bases-wordpress-final/"
          element={<EvaluationFinaleWP />}
        ></Route>
        {/* RENFORCEMENT BUREAUTIQUE */}
        <Route
          path="/evaluation-initiale-renforcement-bureautique/"
          element={<EvaluationInitialeRenforcementBureautique />}
        ></Route>
        <Route
          path="/exercice-renforcement-bureautique/"
          element={<ExerciceMiParcoursRenforcementBureautique />}
        ></Route>
        <Route
          path="/evaluation-finale-renforcement-bureautique/"
          element={<EvaluationFinaleRenforcementBureautique />}
        ></Route>
        {/* */}
        <Route path="/mentions-legales/" element={<MentionsLegales />}></Route>
        {/* <Route path="*" element={<Erreur />}></Route> */}
      </Routes>
    </HashRouter>
  );
}

export default App;
